<template>
    <div v-if="attributesFormatted && attributesFormatted.length > 0">
        <v-expansion-panels flat accordion :value="isAccordionOpen()" class="section row"
            v-if="section.displayType && section.displayType.startsWith('accordion-')">
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0">
                    {{ getLabel() }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <AttributesDisplay :attributesFormatted="attributesFormatted" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div class="section" v-else>
            <div class="section-header row py-4">{{ getLabel() }}</div>
            <AttributesDisplay :attributesFormatted="attributesFormatted" />
        </div>
    </div>
</template>

<script>
import AttributesDisplay from './AttributesDisplay';

export default {
    name: "Section",
    props: {
        section: Object,
        attributesFormatted: Array,
        lang: String,
    },
    data() {
        return {
            empty: false,
        };
    },
    methods: {

        getLabel() {
            if (this.section.labels !== undefined && this.section.labels.length > 0) {
                for (let i = 0; i < this.section.labels.length; i++) {
                    if (this.section.labels[i].lang === this.lang) {
                        return this.section.labels[i].value;
                    }
                }
            }
            return this.section.name;
        },

        isAccordionOpen() {
            return this.section.displayType === "accordion-open" ? 0 : undefined;
        },
    },
    components: { AttributesDisplay }
}
</script>
<style lang="scss" scoped>
.section {
    padding-top: 3%;
    padding-bottom: 2%;
    padding-left: 1%;
    border-radius: 0;
    border-bottom-width: 0px !important;
}

.v-expansion-panel-header,
.section-header {
    font-size: 1.2em;
    font-weight: bold;
    color: #1D71B8;
    padding-top: 1% !important;
}

::v-deep .v-expansion-panel-content>.v-expansion-panel-content__wrap {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
</style>